import { SortableFilter }          from './../common/sortable-filter';

export class KitchenSortableFilter extends SortableFilter {
    public activeOnly = true;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/kitchen-list/kitchen-sortable-filter.ts